import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { FieldViewModel } from "../models/field/field-layout-view-model.model";
import { FileType } from "../models/ui/file.model";
import { FileRecord } from "../models/ui/file.model";
import { CreateProductionWithheldExcelLogRequest } from "../models/ui/job-request/create-production-withheld-excel-log-request.model";
import { ProductionJobSdk } from "../sdks/production-job.sdk";
import { ProcessingManager } from "./processing.manager";
import { ProductionJobView } from "@models/ui/production-job-view.model";

@Injectable({
	providedIn: 'root'
})
export class ProductionWithheldManager {
	public currentProduction$: Observable<ProductionJobView>;

	private currentProductionSource: BehaviorSubject<ProductionJobView> = new BehaviorSubject<ProductionJobView>(null);

	constructor(private productionSdk: ProductionJobSdk, private productionJobSdk: ProductionJobSdk, private processingManager: ProcessingManager) {
		this.currentProduction$ = this.currentProductionSource.asObservable();
	}

	public refresh(id: string): void {
		this.productionSdk.get({ id: id }).subscribe((response) => this.currentProductionSource.next(response));
	}

	public getFiles(id: string, type: FileType): Observable<FileRecord[]> {
		return this.productionJobSdk.getWithheldFileList({ id, type });
	}

	public scheduleWithheldExportLog(id: string, type: 'outgoing-production-withheld-log', fields: FieldViewModel[]): Observable<void> {
		const request = new CreateProductionWithheldExcelLogRequest();
		request.stepParams = {
			productionJobId: id,
			fields: fields
		};
		return this.processingManager.scheduleStep({ stepRequest: request });
	}

	public downloadFile(file: FileRecord): Observable<string> {
		return this.productionJobSdk.downloadWithheld({ file });
	}

	public getDownloadWithheldLink(productionJobId: string, title: string): Observable<any> {
		return this.productionJobSdk.getDownloadWithheldLink(productionJobId, title);
	}

	public deleteFile(productionJobId: string, id: string): Observable<void> {
		return this.productionJobSdk.deleteWithheldFile(productionJobId, id);
	}
}
